export default {
  apiUrl: 'http://47.93.42.104:5000/'
  // apiUrl: 'http://127.0.0.1:5000/'
}
